import React from 'react';

import ScrollButton from '../ScrollButton/ScrollButton';
import type { ScrollControlsProps } from '../../../Menu.types';
import { MenuParts } from '../../../constants';
import classes from './ScrollControls.module.scss';

export const ScrollControls: React.FC<ScrollControlsProps> = props => {
  const {
    isScrollBackwardButtonShown,
    isScrollForwardButtonShown,
    scrollPageForward,
    scrollPageToBackward,
    previewState,
  } = props;

  const sharedButtonProps = {
    previewState,
  };

  return (
    <div className={classes.root}>
      <ScrollButton
        direction="backward"
        onClick={scrollPageToBackward}
        isHidden={!isScrollBackwardButtonShown}
        dataPart={MenuParts.ScrollBackwardButton}
        {...sharedButtonProps}
      />
      <ScrollButton
        direction="forward"
        onClick={scrollPageForward}
        isHidden={!isScrollForwardButtonShown}
        dataPart={MenuParts.ScrollForwardButton}
        {...sharedButtonProps}
      />
    </div>
  );
};
